import { makeAutoObservable, onBecomeObserved } from "mobx"

import { notify } from "@src/app/components/notify"
import { APIPagination, bankAccountsApi } from "@src/shared/api"
import { BankAccountResponse } from "@src/shared/api/generated"

export type FormData = {
  bank_address: string
  bank_name: string
  beneficiary_account_name: string
  beneficiary_account_number: string
  beneficiary_address: string
  bic_swift_code: string
  currency: any
  name: string
  transfer: any
}

class BankAccountsStore {
  private _bankAccounts?: BankAccountResponse[] = []

  chooseBankAccount = async (id: string) => {
    try {
      this.isLoading = true

      const { data: result } = await bankAccountsApi.getBankAccount(id)

      if (result.success) {
        this.chosenBankAccount = result.data
      } else {
        notify.error()
      }
    } catch (catchErrors) {
    } finally {
      this.isLoading = false
    }
  }

  chosenBankAccount?: BankAccountResponse

  createBankAccount = (data: FormData) => {
    const { currency, name, transfer, ...rest } = data

    this.isLoading = true

    return bankAccountsApi
      .createBankAccount({ currency, details: { ...rest }, name, transfer })
      .then(() => {
        this.loadBankAccounts()
      })
      .finally(() => {
        this.isLoading = false
      })
  }

  deleteBankAccount = (id: string) => {
    this.isLoading = true

    return bankAccountsApi
      .deleteBankAccount(id)
      .then(() => this.loadBankAccounts())
      .finally(() => (this.isLoading = false))
  }

  isLoading = false

  loadBankAccounts = async (offset = 0, order?: "asc" | "desc") => {
    try {
      this.isLoading = true

      const { data: result } = await bankAccountsApi.getBankAccounts(
        order,
        offset,
        this.pageSize,
      )

      if (result.success) {
        this._bankAccounts = result.data?.data

        this.total = result.data?.pagination?.total
      } else {
        notify.error()
      }
    } catch (catchErrors) {
    } finally {
      this.isLoading = false
    }
  }

  pageSize = 25

  resetBankAccount = () => (this.chosenBankAccount = undefined)

  total?: APIPagination["total"]

  constructor() {
    makeAutoObservable(this)

    onBecomeObserved(this, "_bankAccounts", this.loadBankAccounts)
  }

  get bankAccounts() {
    return this._bankAccounts?.map((item) => ({ key: item.id, ...item })) || []
  }

  get bankAccountsOptions() {
    return (
      this._bankAccounts?.map((item) => ({
        label: item.name,
        value: item.id,
      })) || []
    )
  }
}

export const bankAccountsStore = new BankAccountsStore()
